export default __webpack_public_path__ + "static/media/vya_logo.b69e1c96.png";